module.exports = __webpack_public_path__ + "img/pota-carlos.7cd7d0d7.png";